// extracted by mini-css-extract-plugin
module.exports = {"wrap":"PageView_wrap__yEggo","content":"PageView_content__3ISLH"};